export default {
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    MEDIUM_TWO: 'MEDIUM_TWO',
    LARGE: 'LARGE',
    DESKTOP_PRODUCT_MODAL: 'LARGE',
}
